var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#EFF1F6",
    width: 1,
    height: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 7V5c0-1.484 1.242-2.667 2.75-2.667h3.5c1.508 0 2.75 1.183 2.75 2.667v2H19a3 3 0 013 3v8a3 3 0 01-3 3H5a3 3 0 01-3-3v-8a3 3 0 013-3h2.5zm2 0h5V5c0-.357-.325-.667-.75-.667h-3.5c-.425 0-.75.31-.75.667v2zM5 9a1 1 0 00-1 1v8a1 1 0 001 1h2.5V9H5zm4.5 0v10h5V9h-5zm7 0v10H19a1 1 0 001-1v-8a1 1 0 00-1-1h-2.5z",
    clipRule: "evenodd",
    fillOpacity: 0.75,
    fill: "#EFF1F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience);
export default __webpack_public_path__ + "static/media/work-experience.b93d68782f50ef96d5bb02238035dec1.svg";
export { ForwardRef as ReactComponent };